// Captura el device_id de MercadoPago (huella antifraude) para Checkout Pro.
// Embebe una sola vez el script oficial de seguridad de MP, que setea
// window.MP_DEVICE_SESSION_ID. Ese id se manda al backend y se pasa a MP como
// header X-meli-session-id al crear la preference → sube la calidad de integración
// y, sobre todo, baja la tasa de rechazos (MP evalúa mejor el riesgo del pago).
//
// Best-effort: si el script no llega a setear el id a tiempo, se devuelve null y el
// pago sigue exactamente igual (solo se pierde esa señal). Nunca bloquea el cobro.

let scriptInjected = false

function inject() {
  if (scriptInjected || typeof document === 'undefined') return
  scriptInjected = true
  const s = document.createElement('script')
  s.src = 'https://www.mercadopago.com/v2/security.js'
  s.setAttribute('view', 'checkout')
  s.async = true
  document.head.appendChild(s)
}

// Llamar al montar el checkout para que el id esté listo cuando el usuario paga.
export function initMpDeviceId() { inject() }

// Devuelve el device id, esperando hasta ~timeoutMs a que el script lo setee. null si no llega.
export function getMpDeviceId(timeoutMs = 2500) {
  inject()
  return new Promise((resolve) => {
    const t0 = Date.now()
    const tick = () => {
      const id = typeof window !== 'undefined' ? window.MP_DEVICE_SESSION_ID : null
      if (id) return resolve(id)
      if (Date.now() - t0 >= timeoutMs) return resolve(null)
      setTimeout(tick, 150)
    }
    tick()
  })
}
